import { render, staticRenderFns } from "./RankChange.vue?vue&type=template&id=8c799b5a&"
import script from "./RankChange.vue?vue&type=script&lang=js&"
export * from "./RankChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports